<template lang="pug">
  #team-center-settings
    WtTile(ancestor)
      WtTile(class="custom-container")
        WtTile(vertical)
          WtTile(parent v-if="isProTier")
            OrganizationTeamsNavigator
          WtTile(parent :col="12")
            WtTile(ancestor vertical :col="12")
              WtTile(parent)
                WtTile.teams-list-title(
                  child
                  :col="12"
                  :is-loading="!programLoaded"
                )
                  TeamProgramSettings
              WtTile(:col="12" v-if="isTeamsFeatureOn")
                WtTile(parent :col="6")
                  WtTile.teams-list-title(
                    child
                    :col="12"
                    :is-loading="!programTeamsLoaded || isSearching"
                  )
                    TeamList(
                      :teams-response-object="localTeamsResponseObject"
                      @search="onSearch($event)"
                      :fetch-action="getProgramTeams"
                    )
                WtTile(parent :col="6")
                  WtTile.teams-list-title(
                    child
                    :col="12"
                    :is-loading="!programTeamsLoaded || isSearching"
                  )
                    UnassignedMembers(
                      :teams-response-object="localTeamsResponseObject"
                      @searchTeams="onSearch($event)"
                      :fetch-teams-action="fetchProgramTeams"
                    )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/eventBus";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import TeamProgramSettings from "@@/TeamCenterAdmin/TeamProgramSettings";
import TeamList from "@@/TeamCenterAdmin/TeamList";
import UnassignedMembers from "@@/TeamCenterAdmin/UnassignedMembers";
import OrganizationTeamsNavigator from "@@/OrganizationsSettingsAdmin/OrganizationsTeamsNavigator";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "TeamCenterSettings",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    TeamProgramSettings,
    TeamList,
    UnassignedMembers,
    OrganizationTeamsNavigator
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      perPage: 5,
      localTeamsResponseObject: {},
      isSearching: false,
      searchQuery: ""
    };
  },

  computed: {
    ...mapGetters("program", [
      "programLoaded",
      "coreProgramMeta",
      "programTeamsLoaded",
      "programTeamsResponseObject",
      "isTeamsFeatureOn",
      "isProTier"
    ])
  },

  async mounted() {
    EventBus.onProgramTeamsResponse($event => {
      this.localTeamsResponseObject = $event;
    });

    if (this.isTeamsFeatureOn) {
      await this.fetchProgramTeams();
    }

    this.onSearch = this._.debounce(async query => {
      this.searchQuery = query;
      if (query.length > 0) {
        this.isSearching = true;
        const response = await this.searchProgramTeams({
          programId: this.$auth.user().programId,
          query,
          perPage: this.perPage
        });
        this.localTeamsResponseObject = response;
        this.isSearching = false;
      } else {
        this.localTeamsResponseObject = this.programTeamsResponseObject;
      }
    }, 500);
  },

  beforeDestroy() {
    EventBus.offProgramTeamsResponse();
  },

  methods: {
    ...mapActions("program", ["fetchProgramTeams", "searchProgramTeams"]),

    onSearch() {
      // defining this here, but is overwritten in the
      // mounted call.  Using debounce requires this
      // approach in order for it to work when
      // the component instance is available.
    },

    async getProgramTeams(payload) {
      if (this.searchQuery) {
        this.localTeamsResponseObject = await this.searchProgramTeams({
          programId: this.$auth.user().programId,
          query: this.searchQuery,
          perPage: this.perPage,
          page: payload.page
        });
      } else {
        await this.fetchProgramTeams(payload);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#team-center-settings
  padding-bottom: 500px
  .teams-list-title
    min-height: 300px
</style>
